// extracted by mini-css-extract-plugin
module.exports = {"gif":"ImageProtection__gif--1YXJp"};